import { render } from "./PurchaseFooter.vue?vue&type=template&id=1cb181d8"
import script from "./PurchaseFooter.vue?vue&type=script&lang=js"
export * from "./PurchaseFooter.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__